import { render, staticRenderFns } from "./admissionExamination.vue?vue&type=template&id=9eafee20&scoped=true"
import script from "./admissionExamination.vue?vue&type=script&lang=js"
export * from "./admissionExamination.vue?vue&type=script&lang=js"
import style0 from "./admissionExamination.vue?vue&type=style&index=0&id=9eafee20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eafee20",
  null
  
)

export default component.exports